module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.data.form_data) ? _c('a', [_vm._v(_vm._s(_vm.linkText))]) : (_vm.assignmentId !== 0) ? _c('a', {
    attrs: {
      "href": ("/admin/participant/edit/" + _vm.elementId + "/history/" + _vm.assignmentId + "?" + _vm.historyEditQueryParams)
    }
  }, [_vm._v(_vm._s(_vm.linkText))]) : (_vm.moduleId === _vm.moduleType.ACTIVITIES_SERVICES) ? _c('a', {
    attrs: {
      "href": ("/admin/activities-and-services/user/" + _vm.elementId + "/edit/" + _vm.formDataId + "?" + _vm.isOpenQueryParam)
    }
  }, [_vm._v(_vm._s(_vm.linkText))]) : (_vm.moduleId === _vm.moduleType.ASSESSMENT_OUTCOMES) ? _c('a', {
    attrs: {
      "href": ("/admin/assessment-and-outcomes/user/" + _vm.elementId + "/edit/" + _vm.formDataId + "?" + _vm.isOpenQueryParam)
    }
  }, [_vm._v(_vm._s(_vm.linkText))]) : (_vm.moduleId === _vm.moduleType.PARTICIPANT_PROFILE) ? _c('a', {
    attrs: {
      "href": ("/admin/participant/edit/" + _vm.elementId)
    }
  }, [_vm._v(_vm._s(_vm.linkText))]) : (_vm.moduleId === _vm.moduleType.PARTICIPANT_ASSIGNMENT) ? _c('a', {
    attrs: {
      "href": ("/admin/participant/edit/" + _vm.elementId + "/assignment")
    }
  }, [_vm._v(_vm._s(_vm.linkText))]) : (_vm.moduleId === _vm.moduleType.PARTICIPANT_CONTACT) ? _c('a', {
    attrs: {
      "href": ("/admin/participant/edit/" + _vm.elementId + "/contact")
    }
  }, [_vm._v(_vm._s(_vm.linkText))]) : (_vm.moduleId === _vm.moduleType.ORGANIZATION_GENERAL) ? _c('a', {
    attrs: {
      "href": ("/admin/general-forms/edit/" + _vm.formDataId + "?" + _vm.isOpenQueryParam)
    }
  }, [_vm._v(_vm._s(_vm.linkText))]) : _c('span', [_vm._v(_vm._s(_vm.linkText))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-699c96c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusables/FormEditLink.vue
// module id = 1683
// module chunks = 1